import React from 'react';
import { CajaRecordType } from './../../../../types';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import './CajaRecordDetail.scss';
import { FaCircleCheck, FaCircleXmark } from 'react-icons/fa6';
import TableDateFormatter from '../../../../../../../../../../components/common/Table/TableDateFormatter';
import { formatCurrency } from '../../../../../../../../../../utils/functions';

interface RenderDetailsProps {
  show: boolean;
  setShow: (show: boolean) => void;
  record: CajaRecordType | null;
}

const CajaRecordDetail: React.FC<RenderDetailsProps> = ({ show, setShow, record }) => {
  if (!record) return null;

  return (
    <Modal show={show} onHide={() => setShow(false)} centered className="caja-record-detail-modal">
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Detalle de Arqueo</Modal.Title>
        </div>
      </Modal.Header>
      
      <Modal.Body>
        {/* General Information Section */}
        <div className="record-section">
          <div className="record-value">
            <div className="badge-label">Usuario</div>
            <div className="badge-content">{record.user_name}</div>
          </div>
          <div className="record-value">
            <div className="badge-label">Período</div>
            <div className="badge-content">
              <TableDateFormatter
                data={record.session_start}
                isRealTime={false}
                stopCounting={true}
                isTimestamp={true}
              /> - <TableDateFormatter
                data={record.session_end}
                isRealTime={false}
                stopCounting={true}
                isTimestamp={true}
              />
            </div>
          </div>
        </div>

        {/* Difference Container - Hero Section */}
        <div className={`difference-container ${record.difference === 0 ? 'difference-green' : 'difference-red'}`}>
          <Row>
            <Col className="difference-label">Diferencia Total:</Col>
            <Col className="difference-value">
              {formatCurrency(record.difference)}
            </Col>
          </Row>
        </div>

        {/* Payment Types Section */}
        <div className="record-section">
          <h5>Detalles de Tipos de Pago</h5>
          <Row className="details-header">
            <Col className="header-label">Tipo</Col>
            <Col className="header-label">Sistema</Col>
            <Col className="header-label">Reportado</Col>
            <Col className="header-label">Estado</Col>
          </Row>
          {Object.entries(record.details.types).map(([type, details]) => (
            <Row key={type} className="details-row">
              <Col className="details-label">{details.payment_type_name}</Col>
              <Col className="details-value">{formatCurrency(details.system)}</Col>
              <Col className="details-value">{formatCurrency(details.reported)}</Col>
              <Col className="details-value">
                {details.matched ? (
                  <FaCircleCheck className="difference-green" />
                ) : (
                  <FaCircleXmark className="difference-red" />
                )}
              </Col>
            </Row>
          ))}
        </div>

        {/* Caja Movements Section */}
        <div className="record-section">
          <h5>Movimientos de Caja</h5>
          <Row className="details-header">
            <Col className="header-label">Caja</Col>
            <Col className="header-label">Sistema</Col>
            <Col className="header-label">Reportado</Col>
            <Col className="header-label">Estado</Col>
          </Row>
          {Object.entries(record.details.caja_movements).map(([workstationId, details]) => (
            <Row key={workstationId} className="details-row">
              <Col className="details-label">{details.name}</Col>
              <Col className="details-value">{formatCurrency(details.system)}</Col>
              <Col className="details-value">{formatCurrency(details.reported)}</Col>
              <Col className="details-value">
                {(details.reported === details.system) ? (
                  <FaCircleCheck className="difference-green" />
                ) : (
                  <FaCircleXmark className="difference-red" />
                )}
              </Col>
            </Row>
          ))}
        </div>

        {/* Tips Section */}
        <div className="record-section">
          <h5>Propinas</h5>
          <Row className="details-header">
            <Col className="header-label">Propina</Col>
            <Col className="header-label">Sistema</Col>
            <Col className="header-label">Reportado</Col>
            <Col className="header-label">Estado</Col>
          </Row>
          {record.details.tips &&
            Object.entries(record.details.tips).map(([tipName, details]) => (
              <Row key={tipName} className="details-row">
                <Col className="details-label">{details.name}</Col>
                <Col className="details-value">{formatCurrency(details.system)}</Col>
                <Col className="details-value">{formatCurrency(details.reported)}</Col>
                <Col className="details-value">
                  {(details.reported === details.system) ? (
                    <FaCircleCheck className="difference-green" />
                  ) : (
                    <FaCircleXmark className="difference-red" />
                  )}
                </Col>
              </Row>
            ))}
        </div>

        {/* Notes Section */}
        <div className="record-section">
          <h5>Notas</h5>
          <div className="record-notes">{record.notes || ''}</div>
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className="form-button-cancel" onClick={() => setShow(false)}>
            Cerrar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CajaRecordDetail;
